export const NEW_ERROR_ACTION = 'NEW_ERROR_ACTION'
export const READ_ERROR_ACTION = 'READ_ERROR_ACTION'
export const READ_ALL_ERROR_ACTION = 'READ_ALL_ERROR_ACTION'

/**
 * Creates a new REST error (redux-action).
 * @param {object} error
 * @param {string} resourceName
 */
export function createNewRestErrorAction(error, resourceName) {
    return createNewErrorAction(error, 'rest', { resourceName })
}

/**
 * Creates a new error of a given type (redux-action).
 * @param {object} error
 * @param {string} errorType
 * @param {object} [data=null]
 */
export function createNewErrorAction(error, errorType, data = null) {
    return {
        type: NEW_ERROR_ACTION,
        errorType,
        error,
        data
    }
}

/**
 * Mark one error as read (i.e. acknowledged) (redux-action).
 * @param {number} errorId
 */
export function markErrorAsReadAction(errorId) {
    return {
        type: READ_ERROR_ACTION,
        errorId
    }
}

/**
 * Mark all errors as read (redux-action).
 * @param {string} errorType    - don't pass this argument to mark all error-types as read
 */
export function markAllErrorsAsReadAction(errorType) {
    return {
        type: READ_ALL_ERROR_ACTION,
        errorType
    }
}

/**
 * Redux reducer for errors.
 * @param {object} state
 * @param {object} action
 */
export default function errorReducer(state = [], action) {
    switch (action.type) {
        case NEW_ERROR_ACTION: {
            return newErrorReducer(state, action)
        }
        case READ_ERROR_ACTION: {
            return readErrorReducer(state, action)
        }
        case READ_ALL_ERROR_ACTION: {
            return readAllErrorReducer(state, action)
        }
        default:
            return state
    }
}

/**
 * Redux reducer to store a new error object.
 * @param {object} state
 * @param {object} action
 */
function newErrorReducer(state, action) {
    const newState = copyErrorState(state)
    newState.push({
        id: newState.length,
        error: action.error,
        errorType: action.errorType,
        timestamp: new Date(),
        data: action.data,
        read: false
    })
    return newState
}

/**
 * Redux reducer to mark one error object of a given type as read.
 * @param {object} state
 * @param {object} action
 */
function readErrorReducer(state, action) {
    const newState = copyErrorState(state)
    const error = newState.find(someError => someError.id === action.errorId)
    if (error) {
        error.read = true
    }
    return newState
}

/**
 * Redux reducer to mark all errors of a given type as read (or all errors, if no type is given).
 * @param {object} state
 * @param {object} action
 */
function readAllErrorReducer(state, action) {
    const newState = copyErrorState(state)
    newState.forEach(error => {
        error.read = !action.errorType || error.read ? true : error.errorType === action.errorType
    })
    return newState
}

/**
 * makes a copy of the error state
 * @param {object} state
 */
function copyErrorState(state = []) {
    return Array.from(state, error => Object.assign({}, error))
}
